/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringPair
 */
export interface StringPair {
    /**
     * 
     * @type {string}
     * @memberof StringPair
     */
    readonly key: string;
    /**
     * 
     * @type {string}
     * @memberof StringPair
     */
    readonly value: string;
}

export function StringPairFromJSON(json: any): StringPair {
    return StringPairFromJSONTyped(json, false);
}

export function StringPairFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringPair {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
    };
}

export function StringPairToJSON(value?: StringPair | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


